import { SxProps } from '@mui/material';

export const modalCarouselModalFrameSX: SxProps = {
	zIndex: 99999999,
};

export const containerCarouselModalFrameSX: SxProps = {
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'flex-end',
	width: '100dvw',
	height: '100dvh',
	backgroundColor: 'white',
};

export const contentCarouselModalFrameSX: SxProps = {
	display: 'flex',
	width: '100%',
	height: '100dvh',
	flexDirection: 'column',
	backgroundColor: 'white',
};

export const headerCarouselModalFrameSX: SxProps = {
	height: '50px',
	display: 'flex',
	alignItems: 'center',
	paddingRight: 2,
	justifyContent: 'flex-end',
	backgroundColor: 'white',
};

export const closeButtonCarouselModalFrameSX: SxProps = {
	cursor: 'pointer',
	color: 'black',
	fontSize: 30,
};

export const footerCarouselModalFrameSX: SxProps = {
	width: '100%',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	backgroundColor: 'white',
	paddingX: '20px',
	height: '80px',
};

export const sliderImageFrameCarouselModalFrameSX: SxProps = {
	display: 'flex !important',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
	height: 'calc(100dvh - 130px)',
	backgroundColor: '#CBCACA',
	overflow: 'hidden',
};

export const buttonCarouselModalFrameSX = (disabled: boolean): SxProps => ({
	backgroundColor: disabled ? '#F1F1F1' : '#F1F1F1',
	width: '56px',
	height: '56px',
	borderRadius: '50%',
});

export const iconCarouselModalFrameSX = (disabled: boolean): SxProps => ({
	color: disabled ? '#CBCACA' : '#2C2C2C',
});
